import { apiFetch } from '../lib/api';
import type { NodeTemplate } from '../types/canvas';

const API_BASE = '/api/node-templates';

async function fetchApi(url: string, options: RequestInit = {}) {
  const response = await apiFetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(err.error || response.statusText);
  }
  return response.json();
}

export interface CreateNodeTemplateDto {
  name: string;
  description?: string;
  source_canvas_id: string;
  source_node_id: string;
}

export interface UpdateNodeTemplateDto {
  name?: string;
  description?: string;
}

export const nodeTemplateService = {
  async list(): Promise<NodeTemplate[]> {
    const response = await fetchApi(API_BASE);
    return response.data;
  },

  async get(id: string): Promise<NodeTemplate> {
    const response = await fetchApi(`${API_BASE}/${id}`);
    return response.data;
  },

  async create(dto: CreateNodeTemplateDto): Promise<NodeTemplate> {
    const response = await fetchApi(API_BASE, {
      method: 'POST',
      body: JSON.stringify(dto),
    });
    return response.data;
  },

  async update(id: string, dto: UpdateNodeTemplateDto): Promise<NodeTemplate> {
    const response = await fetchApi(`${API_BASE}/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(dto),
    });
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await fetchApi(`${API_BASE}/${id}`, {
      method: 'DELETE',
    });
  },
};
